import { Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { RelativeTimeComponent } from './relative-time.component';

interface RelativeTimeProps extends FormlyFieldProps {
  maxDateRelative: string;
  minDateRelative: string;
  units: ('weeks' | 'days' | 'hours' | 'minutes')[];
}

export interface FormlyRelativeTimeFieldConfig extends FormlyFieldConfig<RelativeTimeProps> {
  type: 'relative-time' | Type<FormlyRelativeTimeComponent>;
}

@Component({
  imports: [ReactiveFormsModule, RelativeTimeComponent],
  selector: 'vectronic-formly-relative-time-wrapper',
  template: `
    <vectronic-formly-relative-time
      [formControl]="formControl"
      [minDateRelative]="props?.minDateRelative"
      [maxDateRelative]="props?.maxDateRelative"
      [units]="props?.units ?? ['weeks', 'days', 'hours']"
      [label]="props?.label"
      [defaultValue]="field.defaultValue"
    ></vectronic-formly-relative-time>
  `,
})
export class FormlyRelativeTimeComponent extends FieldType<FieldTypeConfig<RelativeTimeProps>> {}
